<template>
  <v-autocomplete
    :value="value"
    @input="
      $emit('input', $event || null);
      search = null
    "
    v-bind="selectProps"
    :search-input.sync="search"
    :filter="filter"
    @keypress.enter.prevent="createNewItem()"
  >
    <template v-slot:no-data>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>
            <span>No results matching "<strong>{{ search }}</strong>".</span>
            <span
              v-if="!disableCreation"
            >&nbsp;Press <kbd>enter</kbd> to create a new one</span>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-autocomplete>
</template>

<script>
function normalize(s) {
  return s.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
}

export default {
  name: 'Combobox',
  props: {
    value: { // v-model binding
      type: [Array, Number, String]
    },
    disableCreation: {
      type: Boolean,
      default: false
    },
    selectProps: {
      type: Object,
      default() { return [] }
    }
  },
  data() {
    return {
      search: null
    }
  },
  methods: {
    createNewItem() {
      if (this.disableCreation) return
      this.$emit('create-new-item', this.search)
      this.search = null
    },
    filter(item, queryText, itemText) {
      const q = normalize(queryText)
      const t = normalize(itemText)
      return q.split(' ').every(s => t.indexOf(s) > -1)
    }
  }
}
</script>
